/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let roomCreateURL = root.roomCreateUrl.link;
let mediaListUrlLink = root.vistaMediaListLink.link;
let vistaUnstyledMediaListLink = root.vistaUnstyledMediaListLink.link;
let commentOnVideoApiUrl = root.commentOnVideoApiUrl.link;
let getListVistaPrivateOfVideoApiURL = root.getListVistaPrivateOfVideoApiUrl.link;
let getListVistaPublicOfVideoApiURL = root.getListVistaPublicOfVideoApiUrl.link;
let privateVideosListApiUrl = root.privateVideosListApiUrl.link;


export default {
  state: {
    vistaPrivateMediaListState:{},
    vistaPublicMediaListState:{},
    vistaUnstyledMediaListState:{},
    getCommentListOnVideoState:{},
    getListVistaPrivateOfVideoState:{},
    getListVistaPublicOfVideoState:{},
    privateVideosListState:{}
  },
  mutations: {
    vistaPrivateMediaListMutation(state, value) {
      Vue.set(state, 'vistaPrivateMediaListState', value);
    },
    vistaPublicMediaListMutation(state, value) {
      Vue.set(state, 'vistaPublicMediaListState', value);
    },
    vistaUnstyledMediaListMutation(state, value) {
      Vue.set(state, 'vistaUnstyledMediaListState', value);
    },
    getCommentListOnVideoMutation(state, value) {
      Vue.set(state, 'getCommentListOnVideoState', value);
    },
    getListVistaPrivateOfVideoMutation(state, value) {
      Vue.set(state, 'getListVistaPrivateOfVideoState', value);
    },
    getListVistaPublicOfVideoMutation(state, value) {
      Vue.set(state, 'getListVistaPublicOfVideoState', value);
    },
    privateVideosListMutation(state, value) {
      Vue.set(state, 'privateVideosListState', value);
    },
  },
  actions: {
    // Get Private Media List
    getPrivateMediaListFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(privateVideosListApiUrl).then(res => {
              context.commit('privateVideosListMutation', res.data);
              resolve(res);
          }).catch(err => {
              reject(err);
          })
      })
    },
    postCommentOnVideoFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(commentOnVideoApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    getCommentOnVideoByIDFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(commentOnVideoApiUrl + '?item_id=' + payload.id).then(res => {
              context.commit('getCommentListOnVideoMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Vista Unstyled Media List
    vistaUnstyledMediaListFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(vistaUnstyledMediaListLink).then(res => {
              context.commit('vistaUnstyledMediaListMutation', res.data);
              resolve(res);
          }).catch(err => {
              reject(err);
          })
      })
    },
    videoRoomIdGeneratedMethod(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(roomCreateURL, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    // Vista Private Media List
    vistaPrivateMediaListFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(mediaListUrlLink, payload).then(res => {
              context.commit('vistaPrivateMediaListMutation', res.data);
              resolve(res);
          }).catch(err => {
              reject(err);
          })
      })
    },
    // Vista Public Media List
    vistaPublicMediaListFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(mediaListUrlLink, payload).then(res => {
              context.commit('vistaPublicMediaListMutation', res.data);
              resolve(res);
          }).catch(err => {
              reject(err);
          })
      })
    },
    // Vista Private Media List
    getListVistaPrivateOfVideoFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(getListVistaPrivateOfVideoApiURL, payload).then(res => {
              context.commit('getListVistaPrivateOfVideoMutation', res.data);
              resolve(res);
          }).catch(err => {
              reject(err);
          })
      })
    },
    // Vista Public Media List
    getListVistaPublicOfVideoFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.get(getListVistaPublicOfVideoApiURL, payload).then(res => {
              context.commit('getListVistaPublicOfVideoMutation', res.data);
              resolve(res);
          }).catch(err => {
              reject(err);
          })
      })
    },
  },
  getters: {
    getVistaPrivateMediaListState : state => state.vistaPrivateMediaListState,
    getVistaPublicMediaListState : state => state.vistaPublicMediaListState,
    vistaUnstyledMediaListGetters : state => state.vistaUnstyledMediaListState,
    getCommentListOnVideoGetters : state => state.getCommentListOnVideoState,
    getListVistaPrivateOfVideoGetters : state => state.getListVistaPrivateOfVideoState,
    getListVistaPublicOfVideoGetters : state => state.getListVistaPublicOfVideoState,
    privateVideosListGetters : state => state.privateVideosListState
  }
}